import {PublicSaveAction} from "@/constants/Form1099NECPrearationConstants";

export default class SavePublicForm1099NECPreparationPayload {
    action?: PublicSaveAction;
    rejectionReason?: string;

    constructor(init?: Partial<SavePublicForm1099NECPreparationPayload>) {
        Object.assign(this, init);
    }
}